(function () {
  // Dresses the 17TRACK app page to match the Track Your Order design.
  // Runs only on the app proxy path; everything else is untouched.
  if (!/^\/apps\/17track/i.test(window.location.pathname)) return;

  document.body.classList.add('md-17t');

  // The CSS hides #yq-trackingBox while body.md-17t is set and reveals it once
  // md-17t-ready lands, so the widget and the branding appear together instead
  // of the bare widget flashing first.
  function ready() {
    if (document.body) document.body.classList.add('md-17t-ready');
  }

  // Two independent nets, armed before anything else can fail, so the widget is
  // never left cloaked -- even if 17TRACK never renders or build() throws.
  setTimeout(ready, 6000);
  window.addEventListener('load', function () { setTimeout(ready, 2000); });

  var SHIELD = "<svg viewBox='0 0 24 24' fill='none' stroke='#b09a86' stroke-width='1.5'>" +
    "<path d='M12 2.6 4.4 5.9v6.2c0 4.6 3.2 8 7.6 8.9 4.4-.9 7.6-4.3 7.6-8.9V5.9z'/>" +
    "<path d='m9 12 2.2 2.2 4-4.2'/></svg>";

  var HEADSET = "<svg viewBox='0 0 24 24' fill='none' stroke='#111' stroke-width='1.4'>" +
    "<path d='M4 14v-2a8 8 0 0 1 16 0v2'/>" +
    "<rect x='2.6' y='13.6' width='4.2' height='6' rx='1.6'/>" +
    "<rect x='17.2' y='13.6' width='4.2' height='6' rx='1.6'/></svg>";

  function build(box) {
    if (document.querySelector('.md-17t-hero')) return;

    var hero = document.createElement('div');
    hero.className = 'md-17t-hero';
    hero.innerHTML =
      "<div class='md-17t-mark' aria-hidden='true'>MD</div>" +
      '<h1>' + (window.mdT || function (k, f) { return f; })('md_17track.title', 'Track Your Order') + '</h1>' +
      "<div class='md-17t-rule'></div>" +
      '<p>' + (window.mdT || function (k, f) { return f; })('md_17track.subtitle', 'Track your order in real time and stay updated every step of the way.') + '</p>';
    box.parentNode.insertBefore(hero, box);

    var secure = document.createElement('div');
    secure.className = 'md-17t-secure';
    secure.innerHTML = "<span class='ic'>" + SHIELD + '</span>' +
      '<p>' + (window.mdT || function (k, f) { return f; })('md_17track.secure_note', 'Your information is secure and will only be used to process your order tracking.') + '</p>';
    box.appendChild(secure);

    var help = document.createElement('div');
    help.className = 'md-17t-help';
    help.innerHTML =
      "<span class='ic'>" + HEADSET + '</span>' +
      "<div class='md-17t-help-t'><b>" + (window.mdT || function (k, f) { return f; })('md_17track.need_help', 'Need Help?') + '</b>' +
      '<span>' + (window.mdT || function (k, f) { return f; })('md_17track.help_text', 'Our support team is here to help you with any questions about your order.') + '</span></div>' +
      "<a class='md-17t-cta' href='/pages/contact-us'>" + (window.mdT || function (k, f) { return f; })('md_17track.contact_us', 'Contact us') + '</a>';
    box.parentNode.insertBefore(help, box.nextSibling);

    ready();
  }

  // The widget is React-rendered, so wait for it rather than assuming it exists.
  var tries = 0;
  (function wait() {
    var box = document.getElementById('yq-trackingBox');
    if (box) { build(box); return; }
    if (tries++ < 60) setTimeout(wait, 200);
    else ready();
  })();

  // Keep the security note last inside the card if the widget re-renders.
  if (window.MutationObserver) {
    new MutationObserver(function () {
      var box = document.getElementById('yq-trackingBox');
      var note = document.querySelector('.md-17t-secure');
      if (box && note && note.parentNode === box && box.lastElementChild !== note) {
        box.appendChild(note);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
